module.exports = function(data) {
var __t, __p = '';
__p += '<label for="i' +
((__t = ( data.cid )) == null ? '' : __t) +
'" class="sr-only"><span id="errPassword">' +
((__t = ( strings.login.newPassword )) == null ? '' : __t) +
'</span></label>\n<input data-placement="left" autocomplete="new-password" spellcheck="false" id="i' +
((__t = ( data.cid )) == null ? '' : __t) +
'" type="password" class="form-control input-lg password-input" placeholder="New password">\n<span class="showPassword" data-toggle="tooltip" title="' +
((__t = ( strings.login.showPasswordTooltip )) == null ? '' : __t) +
'">\n    <i class="far fa-eye"></i>\n</span>\n';
return __p
}